import { render, staticRenderFns } from "./交易指南.vue?vue&type=template&id=7acae86f&scoped=true"
import script from "./交易指南.vue?vue&type=script&lang=js"
export * from "./交易指南.vue?vue&type=script&lang=js"
import style0 from "./交易指南.vue?vue&type=style&index=0&id=7acae86f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acae86f",
  null
  
)

export default component.exports